import React, { useState, useEffect } from 'react';
import SelectedBox from 'components/elements/checkbox/selectedBox';
import UnselectedBox from 'components/elements/checkbox/unselectedBox';

type Props = {
	handleCheck: any;
	value: any;
	selectState: any;
	id?: string;
};

const TvsCheckBox = ({
	handleCheck,
	value,
	selectState,
	id = 'check-box',
}: Props) => {
	return (
		<>
			{selectState ? (
				<button
					id={id}
					type='button'
					onClick={() => {
						handleCheck(value, false);
					}}
					style={{ borderWidth: 0, backgroundColor: 'transparent' }}>
					<SelectedBox />
				</button>
			) : (
				<button
					id={id}
					type='button'
					onClick={() => {
						handleCheck(value, true);
					}}
					style={{ borderWidth: 0, backgroundColor: 'transparent' }}>
					<UnselectedBox />
				</button>
			)}
		</>
	);
};

export default TvsCheckBox;
